module.exports = __webpack_public_path__ + "0341776ea959b3e48ce401edb7b03fd7.jpg";